import { Lightning, Colors } from "@lightningjs/sdk";
import theme from "../../../../lib/theme";

interface GroupTitleTemplateSpec extends Lightning.Component.TemplateSpec {
    Title: object;
}

export class GroupTitle
    extends Lightning.Component<GroupTitleTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<GroupTitleTemplateSpec>
{
    private _title = "";

    // Make this component completely non-focusable
    static get focusable() {
        return false;
    }

    override _getFocused() {
        return null; // Never return focus
    }

    static override _template(): Lightning.Component.Template<GroupTitleTemplateSpec> {
        return {
            w: 607,
            h: 60,
            Title: {
                x: 0,
                y: 20,
                text: {
                    text: "",
                    fontFace: "Bold",
                    fontSize: 40,
                    textColor: Colors(theme.colors.text.primary).get(),
                    wordWrapWidth: 600
                }
            }
        };
    }

    readonly Title = this.getByRef("Title")!;

    set title(value: string) {
        this._title = value;
        this.Title.patch({
            text: {
                text: value
            }
        });
    }

    get title(): string {
        return this._title;
    }

    static get height(): number {
        return 60;
    }
}
